import type { FC, ReactNode } from 'react';

import { Fragment } from 'react';

interface ConditionalWrapperProps {
    condition: boolean;
    renderWrapper: (children: ReactNode) => ReactNode;
}

export const ConditionalWrapper: FC<React.PropsWithChildren<ConditionalWrapperProps>> = (props) =>
    // eslint-disable-next-line react/jsx-no-useless-fragment
    props.condition ? <>{props.renderWrapper(props.children)}</> : <>{props.children}</>;

interface ConditionalMultipleWrappersProps {
    choices: {
        condition: boolean;
        renderWrapper: (children: ReactNode) => ReactNode;
    }[];

    children: ReactNode;
}

export const ConditionalMultipleWrappers: FC<
    React.PropsWithChildren<ConditionalMultipleWrappersProps>
> = (props) => {
    return (
        <>
            {props.choices.map(
                (choice, index) =>
                    choice.condition && (
                        // eslint-disable-next-line react/no-array-index-key
                        <Fragment key={index}>{choice.renderWrapper(props.children)}</Fragment>
                    ),
            )}
        </>
    );
};
